export default __webpack_public_path__ + "static/media/ale-smile.630ec964.png";